import { replaceBackslashN } from "./replaceBackslashN";
import { replaceWhitespaceBetweenJapaneseCharactersWithZwsp } from "./replaceWhitespaceBetweenJapaneseCharactersWithZwsp";

export const transforms: ReadonlyArray<(input: string) => string> = [
  replaceBackslashN,
  replaceWhitespaceBetweenJapaneseCharactersWithZwsp,
];
